import {
  Component,
  ViewEncapsulation,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import Swal from 'sweetalert2';

import { OrdersService } from '../../../../services/orders';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { BundleService } from '../../../../services/bundles';

@Component({
  selector: 'app-addbundle',
  templateUrl: './addbundle.component.html',
  styleUrls: ['./addbundle.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddbundleComponent implements OnInit {

  contentReady = false;
  isAr = localStorage.getItem('language') === 'ar';

  data!: FormGroup;

  productname: any[] = [];
  filteredProviders: any[] = [];

  searchValue = '';

  selectedProductsDetails: {
    product: any;
    quantity: number;
  }[] = [];
  imagePreview: string | null = null;
  imageFile!: File;
  warehouseId = localStorage.getItem('posId');
isMobile: boolean = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private _bundle: BundleService,
    private _orderService: OrdersService,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
        this.isMobile = this.deviceService.isMobileDevice();
    this.initForm();
    this.getAllStockData();
  }

  initForm() {
    this.data = this.fb.group({
      name_en: ['', Validators.required],
      name_ar: ['', Validators.required],
      description_en: [''],
      description_ar: [''],
      price: [, [Validators.required, Validators.min(1)]],
      pricea: [],
      priceb: [],
      pricec: [],
      affiliationprice: []
    });
  }

  getAllStockData() {
    this._orderService.getStocksData(this.warehouseId).subscribe({
      next: (data) => {
        this.productname = data.stocks || [];
        this.filteredProviders = this.productname;
      }
    });
  }

  onSearchChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input?.value || '';

    this.searchValue = value;

    const search = value.toLowerCase();

    this.filteredProviders = this.productname.filter(p =>
      p.name_ar?.toLowerCase().includes(search) ||
      p.name_en?.toLowerCase().includes(search)
    );
  }

  addProduct(event: MatAutocompleteSelectedEvent) {
    const product = event.option.value;

    const exists = this.selectedProductsDetails.find(
      x => x.product.id === product.id
    );

    if (!exists) {
      this.selectedProductsDetails.push({
        product,
        quantity: 1
      });
    }

    this.searchValue = '';
  }

  removeProduct(id: number) {
    this.selectedProductsDetails =
      this.selectedProductsDetails.filter(p => p.product.id !== id);
  }

  trackByProduct(index: number, item: any) {
    return item.product.id;
  }



  onImageSelect(event: any) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };

      reader.readAsDataURL(file);
    }
  }

  get totalCost(): number {
    return this.selectedProductsDetails.reduce(
      (sum, item) => sum + (item.product.price * item.quantity),
      0
    );
  }

  profitFor(value: number): number {
    return (value || 0) - this.totalCost;
  }

  submit() {
    if (
      this.data.invalid ||
      this.selectedProductsDetails.length === 0
    ) return;

    this.contentReady = true;

    const formData = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      formData.append(key, value as any);
    });

    formData.append('warehouse_id', this.warehouseId || '');

    if (this.imageFile) {
      formData.append('image', this.imageFile);
    }

    this.selectedProductsDetails.forEach((item, index) => {
      formData.append(`items[${index}][stock_id]`, item.product.id);
      formData.append(`items[${index}][quantity]`, item.quantity.toString());
    });

    this._bundle.create(formData).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: 'Bundle Created',
          timer: 1500,
          showConfirmButton: false
        });
        this.isMobile? this.router.navigateByUrl('/bundles.mobile') : this.router.navigateByUrl('/bundles');

      },
      error: () => {
        this.contentReady = false;
        Swal.fire('Error', 'Something went wrong', 'error');
      }
    });
  }
}
